import { type Row, type Table } from "@tanstack/react-table";
import { type FC } from "react";

import { DataGridAlphaV3 } from "..";
import { TableCellValueRowDetail } from "./TableCellValueRowDetail";
import { type TableCellValueCommonProps } from "./types";

export interface TableCellValueTableProps extends TableCellValueCommonProps {
	table: Table<unknown>;
	row: Row<unknown>;
	header?: string;
	columnId: string;
	renderAsRowDetail?: boolean;
}

export const TableCellValueTable: FC<TableCellValueTableProps> = ({
	table,
	row,
	value,
	columnId,
	renderAsRowDetail,
}) => {
	if (value === undefined) {
		return null;
	}

	const content = (
		<div className="overflow-auto md:w-[952px]">
			<DataGridAlphaV3 {...value} />
		</div>
	);

	if (renderAsRowDetail) {
		return content;
	}

	return (
		<TableCellValueRowDetail
			rowType="Table"
			value={value}
			table={table}
			columnId={columnId}
			row={row}
		/>
	);
};
